import React from 'react';
const links = ['Terms & Conditions', 'Privacy Policy', 'Contact'];
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-ink-900 px-4 pb-28 pt-10 sm:px-6" data-id="element-130" data-mp="208caozdh8xmx">
      <div className="mx-auto w-full max-w-5xl text-center" data-id="element-131" data-mp="2f53dzjq9utht">
        <p className="font-display text-xl font-bold uppercase tracking-wide text-white" data-id="element-132" data-mp="2f2h59grna7y0">
          Master <span className="text-teal-bright" data-id="element-133" data-mp="2a3w5tjk7vsam">Welding System™</span>
        </p>
        <nav aria-label="Footer" className="mt-4" data-id="element-134" data-mp="1mgfnn9qo1dxe">
          <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-135" data-mp="1hhl588wm1rdt">
            {links.map(link => <li key={link} data-id="element-136" data-mp="1w6r39tjppbk4">
                <a href="#" className="text-[13px] font-medium text-white/50 transition-colors duration-150 ease-out hover:text-teal-bright" data-id="element-137" data-mp="1w825vq1f8d9n">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mt-5 text-[12px] leading-relaxed text-white/35" data-id="element-138" data-mp="yohaek7np8hm">
          © 2026 Master Welding System™ — All Rights Reserved.
        </p>
      </div>
    </footer>;
}